<div class="modal-header bg-dark text-white">
  <h4 class="modal-title pull-left">{{title}}</h4>
  <button type="button" class="close pull-right text-white" aria-label="Close" (click)="bsModalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="form-group row">
    <div class="col-md-5 col-sm-9">
      <label class="form-label">PLZ</label>
      <input class="form-control" type="text" (keyup)="update()" [(ngModel)]="filter.zip" />
    </div>
    <div class="col">
      <label>Ort</label>
      <input class="form-control" type="text" (keyup)="update()" [(ngModel)]="filter.city" />
    </div>
  </div>
  <div class="form-group row">
    <div class="col-md-5 col-sm-9">
      <label>Straße</label>
      <input class="form-control" type="text" (keyup)="update()" [(ngModel)]="filter.street" />
    </div>
    <div class="col">
      <label>Name</label>
      <input class="form-control" type="text" (keyup)="update()" [(ngModel)]="filter.name" />
    </div>
  </div>
  <div class="form-group row">
    <div class="col-md-5 col-sm-9">
      <label>Bezirk</label>
      <select class="form-control" (change)="updateCounty()" [(ngModel)]="filter.county">
        <option value="">- Bezirk -</option>
        <option *ngFor="let county of counties | keyvalue" [value]="county.value.id">{{county.value.name}}</option>
      </select>
    </div>
    <div class="col">
      <label>Gau</label>
      <select class="form-control" (ngModelChange)="updateSubCounty($event)" [ngModel]="filter.sub_county">
        <option value="">- Gau -</option>
        <option *ngFor="let county of filteredSubCounties | keyvalue" [value]="county.value.id">{{county.value.name}}
        </option>
      </select>
    </div>
  </div>
  <div class="form-group row">
    <div class="ml-3">
      <span>Bitte nur wirklich neue Orte anlegen und lieber in Phoenix eine Hausnummer korrigieren als hier einen neuen
        Ort
        anlegen.<br><br>
        Ähnliche Orte, die bereits in Phoenix hintelegt sind:</span>
      <table class="table table-striped mt-2">
        <thead>
          <tr>
            <th>PLZ</th>
            <th>Ort</th>
            <th>Straße</th>
            <th>Name</th>
            <th>Bezirk</th>
            <th>Gau</th>
          </tr>
        </thead>
        <tr *ngFor="let item of filteredLocations; let i=index">
          <!-- <td>{{i + 1}}</td> -->
          <td>{{item.zip}}</td>
          <td>{{item.city}}</td>
          <td>{{item.street}}</td>
          <td>{{item.name}}</td>
          <td>{{item.countyName}}</td>
          <td>{{item.sub_countyName}}</td>
        </tr>
      </table>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="create()" [disabled]="!canCreate">Anlegen</button>
  <button type="button" class="btn btn-danger" (click)="bsModalRef.hide()">{{closeBtnName}}</button>
</div>
